import store from '../state/store';
import router from '../router';

export default class BasicService {
    constructor() {
        let url = process.env.NODE_ENV !== 'development' ? document.location.origin : 'http://51.75.37.170:3000';
        this.API_URL = url + '/api/';
    }

    checkError(result, showErrors = true) {
        return new Promise((resolve, reject) => {
            result.then(
                response => {
                    resolve(response);
                },
                error => {
                    if (!showErrors)
                        return reject(error);

                    if (error.response && error.response.status && error.response.status === 403) {
                        store.dispatch('notification/error', "Nie masz do tego uprawnień!");
                        router.push({name: 'default'});
                    } else if (error.response && error.response.status && error.response.status === 401) {
                        store.dispatch('notification/error', "Minął czas aktywności. Wylogowywanie!");
                        store.dispatch('auth/logout');
                        router.push({name: 'loginToken'});
                    } else {
                        let err = "Undefined error";

                        if (error.response && error.response.data && error.response.data.message)
                            err = error.response.data.message;
                        else if (error.message)
                            err = error.message;
                        else if (error.toString())
                            err = error.toString();

                        store.dispatch('notification/error', err);

                        reject(error);
                    }
                },
            )
        });
    }
}